import { Injectable, inject } from '@angular/core';
import { ToastrService as NgxToastrService } from 'ngx-toastr';
import { ToastrNotification } from '../models/toastr.model';
import { EventManager } from '../utils/event-manager';
import { GameService } from '@app/game/game.service';
import { RouteParameterInterceptor } from './routeParameterInterceptor.service';
import { NotificationsRepository } from '../state/notifications/notifications.repository';

@Injectable({
  providedIn: 'root',
})
export class ToastrService {
  toastrOpened = false;

  private readonly eventManager = inject(EventManager);
  private readonly notificationsRepo = inject(NotificationsRepository);
  private readonly ngxToastrService = inject(NgxToastrService);
  private readonly gameService = inject(GameService);
  private readonly routeParameterInterceptor = inject(RouteParameterInterceptor);

  constructor() {
    this.gameService.gameFinished$.subscribe(() => {
      this.show(this.notificationsRepo.getFirstToastr());
    });

    this.eventManager.enqueueToast$.subscribe((toast) => {
      this.enqueue(toast);
    });

    this.subscribeToCompletedWithGems();
  }

  private subscribeToCompletedWithGems(): void {
    this.eventManager.completedDCWithGems$.subscribe(() => {
      this.showToastrs();
    });
  }

  private showToastrs(): void {
    const nextToast = this.notificationsRepo.getFirstToastr();
    if (nextToast) {
      this.show(nextToast);
    }
  }

  private enqueue(toast: ToastrNotification): void {
    if (toast.instant) {
      if (!this.hasToastrs()) {
        if (toast.delay) {
          setTimeout(() => {
            this.notificationsRepo.addToastr(toast);
            this.show(toast);
          }, toast.delay);
        } else {
          this.notificationsRepo.addToastr(toast);
          this.show(toast);
        }
      } else {
        this.notificationsRepo.setNextToastr(toast);
      }
    } else {
      this.notificationsRepo.addToastr(toast);
    }
  }

  private show(toast: ToastrNotification): void {
    if (this.hasToastrs() && !this.toastrOpened) {
      this.toastrOpened = true;
      const toastr = this.ngxToastrService.show(toast.message?.[0] ?? '', toast.title, toast.options);

      toastr.onTap.subscribe(() => {
        if (toast.actionUrl) {
          this.routeParameterInterceptor.checkActionUrl(toast.actionUrlType, toast.actionUrl, toast.entityId);
        }
      });

      toastr.onHidden.subscribe(() => {
        this.toastrOpened = false;
        this.notificationsRepo.removeToastr(toast.id);

        if (this.hasToastrs()) {
          this.show(this.notificationsRepo.getFirstToastr());
        }
      });
    }
  }

  private hasToastrs(): boolean {
    return this.notificationsRepo.getToastrs().length > 0;
  }
}
